module.exports = __webpack_public_path__ + "static/media/02-2-galeria-01-salon-de-escritura@2x.0393f272.jpg";